import createDataTestIds from './createDataTestIds';
import createForgeProps from './createForgeProps';
import { SetupMethod } from '../types';

const useAlloySetup: SetupMethod = (componentPrefix, props, defaultForgeProps) => {
  return {
    getId: createDataTestIds(componentPrefix, props.dataTestIds),
    forgeProps: createForgeProps(defaultForgeProps, props.forgeProps)
  };
};

export default useAlloySetup;
